// Texto de la autorización que el terapeuta entrega y su paciente firma (/herramientas/consentimiento). La vista
// previa, el PDF y «Copiar texto» leen estas constantes: antes eran tres copias en ConsentimientoClient.tsx y por eso
// la promesa falsa estaba tres veces.
//
// 17-30 (contenido C-2): el párrafo de protección de datos decía «Tus datos personales son anonimizados y cifrados»
// y «TherapyRecap cumple con todas las medidas de seguridad requeridas». El código seudonimiza, no anonimiza: DLP
// cambia nombres e identificadores por marcas en el texto de transcripciones y documentos antes de indexarlo o de
// enviarlo al asistente, y la tabla que lo deshace se guarda cifrada con Cloud KMS (worker dlp.service.js,
// kmsVault.service.js). El audio y los documentos subidos se guardan tal cual hasta su borrado, y el nombre del
// paciente se guarda en claro en su ficha. Por eso el párrafo dice solo lo que el código y la infraestructura
// respaldan, con la redacción de GARANTIA_SEUDONIMIZACION.

export const TITULO_AUTORIZACION = 'AUTORIZACIÓN PARA EL USO DE THERAPYRECAP';

export const SALUDO_AUTORIZACION = 'Estimado/a paciente,';

export const PARRAFO_FINALIDAD =
    'Con el fin de mejorar la calidad de la terapia y poder ofrecerte un servicio más efectivo y personalizado, tu ' +
    'terapeuta utiliza TherapyRecap, una plataforma digital diseñada especialmente para apoyar el trabajo de los ' +
    'psicólogos. Esta herramienta usa inteligencia artificial (IA) para transcribir las sesiones y proporcionar al ' +
    'terapeuta un análisis detallado de cada encuentro, permitiendo dedicar más tiempo a lo que verdaderamente ' +
    'importa: tu bienestar y avance en terapia.';

export const PARRAFO_PROTECCION_DATOS =
    'TherapyRecap trata tus datos por encargo de tu terapeuta, con un contrato de encargado del tratamiento conforme ' +
    'al Reglamento General de Protección de Datos (RGPD) y a la Ley Orgánica de Protección de Datos y Garantía de ' +
    'Derechos Digitales (LOPDGDD). Los datos se alojan en Europa y se transmiten y se guardan cifrados. Los nombres y ' +
    'otros datos identificativos de las transcripciones y de los documentos se sustituyen por marcas antes de que el ' +
    'texto se indexe o llegue al asistente. Tus datos solo se usan para transcribir y documentar tu tratamiento.';

export const PARRAFO_AUTORIZACION =
    'Al firmar este documento, autorizas a tu terapeuta a utilizar TherapyRecap como apoyo en la transcripción y ' +
    'análisis de las sesiones. Esta autorización es voluntaria y puedes revocarla en cualquier momento, informando a ' +
    'tu terapeuta, sin que esto afecte la calidad del servicio recibido.';

export const PARRAFOS_AUTORIZACION = [PARRAFO_FINALIDAD, PARRAFO_PROTECCION_DATOS, PARRAFO_AUTORIZACION] as const;
